import { SUPPLIERS_TEXT } from '@/texts/catalog/suppliers';

const resolveText = (text = SUPPLIERS_TEXT) => {
  return text && typeof text === 'object' ? text : SUPPLIERS_TEXT;
};

export const createSupplierDetailTabs = (text = SUPPLIERS_TEXT) => {
  const source = resolveText(text);

  return [
    { key: 'summary', label: source.detail.tabs.summary },
    { key: 'contact-billing', label: source.detail.tabs.contactBilling },
    { key: 'operation', label: source.detail.tabs.operation },
    { key: 'finance', label: source.detail.tabs.finance },
    { key: 'analysis', label: source.detail.tabs.analysis },
    { key: 'documents', label: source.detail.tabs.documents },
    { key: 'settings', label: source.detail.tabs.settings },
    { key: 'history', label: source.detail.tabs.history },
  ];
};

export const createSupplierDetailOperationSubTabs = (text = SUPPLIERS_TEXT) => {
  const source = resolveText(text);

  return [
    { key: 'expenses', label: source.detail.subTabs.operation.expenses },
    { key: 'commissions', label: source.detail.subTabs.operation.commissions },
    { key: 'refunds', label: source.detail.subTabs.operation.refunds },
  ];
};

export const createSupplierDetailFinanceSubTabs = (text = SUPPLIERS_TEXT) => {
  const source = resolveText(text);

  return [
    { key: 'payments', label: source.detail.subTabs.finance.payments },
    { key: 'cfdis', label: source.detail.subTabs.finance.cfdis },
  ];
};

export const createSupplierDetailAnalysisSubTabs = (text = SUPPLIERS_TEXT) => {
  const source = resolveText(text);

  return [
    { key: 'historical-flow', label: source.detail.subTabs.analysis.historicalFlow },
    { key: 'trends', label: source.detail.subTabs.analysis.trends },
  ];
};
